import React, { useContext, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { DesignContext } from '../../../contexts/DesignContext'

const CustomImage = (props) => {
  const designContext = useContext(DesignContext)
  const { updateUiSchema } = designContext
  const { uischema } = props
  const showDivider = uischema.showDivider

  useEffect(() => {
    if (showDivider === undefined) {
      updateUiSchema(uischema.key, 'showDivider', true)
    }
  }, [])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        <Col
          sm={uischema.layoutWidth}
          className="px-0"
          style={{
            margin: uischema.margin,
            padding: uischema.padding,
          }}
        >
          {showDivider ? <hr className="my-0" /> : <></>}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomImage
